import { useEffect, useState } from 'react'
import CardView from '../../../component/card/card-view';
import { Reseller, Staff } from '../../../models';
import EditAccountMobx from './edit-account-mobx';
import { MobxObjectsManager, useManualRemove } from '../../mobx-objs/mobx-manager';
import { observer } from 'mobx-react-lite';
import AuthGroup, { authGroupData } from '../auth-group/auth-group';
import DialogComponent from '../../../component/dialog/dialog.component';
import Button from '@mui/material/Button';
import ButtonComponent from '../../../component/button/button.component';
import Save from '@mui/icons-material/Save';
import { Box, Grid, Skeleton, Typography } from '@mui/material';
import i18n from 'i18next';
import CardFrom, { CardFormConfig } from '../../../component/card/card-from';
import moment from 'moment';
import LinkIcon from '@mui/icons-material/Link';
import CommonInput from '../../../component/form/common-input.component';
import SearchComponent from '../../../component/form/search-input.component';
import TableComponent, { HeadCell } from '../../../component/table/table.component';
import { groupUnitData } from '../group-unit';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import LockResetIcon from '@mui/icons-material/LockReset';
import _ from 'lodash';

export const editAccountMobx = MobxObjectsManager.get(EditAccountMobx);
export const EditAccount = observer((props: { skeleton: boolean, editing: Staff | null, open: boolean, onClose: () => void }) => {

    const { editing, skeleton, onClose, open } = props;

    const belonged_restaurant = editAccountMobx.viewStaffBaseInfo?.belonged_restaurant;
    const [img, setImg] = useState<string>('');

    useEffect(() => {
        if (open) {
            editAccountMobx.updateEditing(editing);
        } else {
            setImg('')
        }
    }, [open]);

    useManualRemove(EditAccountMobx);

    const tableHead: HeadCell[] = editAccountMobx.disabled ?
        [
            { id: 'nickname', label: i18n.t('general_text_name'), sortStatus: -1 },
            { id: 'string_id', label: i18n.t('ground_staff_component_text_restaurant_code'), sortStatus: -1 },
            {
                id: 'restaurant_belonged_group.nickname', label: i18n.t('general_text_belonged_group'),
                renderFunction: (row: Staff) => {
                    return <>{editAccountMobx.canCombindRestaurantData.open ? row?.belonged_group_info?.[0]?.nickname || '' : row?.restaurant_belonged_group?.nickname || ''}</>
                }
            },
            {
                id: 'restaurant_belonged_group.string_id', label: i18n.t('group_management_page_text_group_identification_code'),
                renderFunction: (row: Staff) => {
                    return <>{editAccountMobx.canCombindRestaurantData.open ? row?.belonged_group_info?.[0]?.string_id || '' : row?.restaurant_belonged_group?.string_id || ''}</>
                }
            },
            { id: 'email', label: i18n.t('general_text_email'), sortStatus: -1 },
        ]
        :
        [
            { id: 'nickname', label: i18n.t('general_text_name'), sortStatus: -1 },
            { id: 'string_id', label: i18n.t('ground_staff_component_text_restaurant_code'), sortStatus: -1 },
            {
                id: 'restaurant_belonged_group.nickname', label: i18n.t('general_text_belonged_group'),
                renderFunction: (row: Staff) => {
                    return <>{editAccountMobx.canCombindRestaurantData.open ? row?.belonged_group_info?.[0]?.nickname || '' : row?.restaurant_belonged_group?.nickname || ''}</>
                }
            },
            {
                id: 'restaurant_belonged_group.string_id', label: i18n.t('group_management_page_text_group_identification_code'),
                renderFunction: (row: Staff) => {
                    return <>{editAccountMobx.canCombindRestaurantData.open ? row?.belonged_group_info?.[0]?.string_id || '' : row?.restaurant_belonged_group?.string_id || ''}</>
                }
            },
            { id: 'email', label: i18n.t('general_text_email'), sortStatus: -1 },
            {
                id: '4', label: i18n.t('bind_account_component_text_bind'), sortStatus: -1,
                renderFunction(row: any) {
                    return renderFeatures(row)
                }
            },
        ];

    // 关联餐厅弹窗
    const editAccountTableHead = ([{
        id: 'belonged_reseller',
        label: i18n.t('reseller_page_text_reseller'),
        renderFunction: (row) => {
            const reseller = _.get(row, 'belonged_reseller.[0]') as Reseller | undefined;
            return <>{reseller ? `${reseller.first_name || ''} ${reseller.last_name || ''}` : 'Admin'}</>
        }
    }] as HeadCell[]).concat(tableHead)


    // 集团切换下拉框
    const groupModeOptions = [
        { value: 'belonged_group', label: i18n.t('dialog_page_bind_account_text_the_group') },
        { value: 'all_group', label: i18n.t('dialog_page_bind_account_text_all_group') }
    ]

    // 弹出绑定框下拉框
    const filterList = [
        {
            value: 'nickname',
            label: i18n.t('general_text_name'),
        },
        {
            value: 'email',
            label: i18n.t('general_text_email')
        }
    ];

    // 员工账号绑定卡片数据
    const accountInfoCardConfig: CardFormConfig[] = [
        {
            key: 'baseInfo',
            title: i18n.t('ground_staff_component_text_basic_information'),
            rowSpacing: 6,
            columnSpacing: { md: 4, xs: 4 },
            children: [
                {
                    comType: 'AVATAR',
                    key: 'avatar',
                    xs: 12,
                    fillback: img,
                    isDisabledUpload: editAccountMobx.disabled,
                    handleChangeAvatar: ((_avatarUrl: string, file: File) => {
                        setImg(_avatarUrl);
                        editAccountMobx.onChangeLogo(file)
                    })
                },
                {
                    key: 'first_name',
                    label: i18n.t('responsible_person_info_component_text_name'),
                    required: true,
                    regularType: 'inputLimit',
                    disabledInput: editAccountMobx.disabled,
                    comType: 'INPUT',
                    inputType: 'INPUT',
                    inputIsEdited: editAccountMobx.op.get('first_name') !== undefined ? true : false,
                    onChange: (e) => {
                        editAccountMobx.handleChangeViewStaffBaseInfo(e, 'first_name');
                    },
                    xs: 12,
                    md: 6,
                    isEmpty: editAccountMobx.allowNullVerification
                },
                {
                    key: 'last_name',
                    label: i18n.t('person_page_text_surname'),
                    required: true,
                    regularType: 'inputLimit',
                    disabledInput: editAccountMobx.disabled,
                    comType: 'INPUT',
                    inputType: 'INPUT',
                    inputIsEdited: editAccountMobx.op.get('last_name') !== undefined ? true : false,
                    onChange: (e) => {
                        editAccountMobx.handleChangeViewStaffBaseInfo(e, 'last_name');
                    },
                    xs: 12,
                    md: 6,
                    isEmpty: editAccountMobx.allowNullVerification
                },
                {
                    key: 'gender',
                    label: i18n.t('general_text_gender'),
                    required: true,
                    disabledInput: editAccountMobx.disabled,
                    comType: 'INPUT',
                    inputType: 'SELECT',
                    inputIsEdited: editAccountMobx.op.get('gender') !== undefined ? true : false,
                    items: [{
                        value: '0',
                        label: i18n.t('person_page_button_male')
                    }, {
                        value: '1',
                        label: i18n.t('person_page_button_female')
                    }],
                    onChange: (e) => {
                        editAccountMobx.handleChangeViewStaffBaseInfo(e, 'gender');
                    },
                    xs: 12,
                    md: 6,
                    isEmpty: editAccountMobx.allowNullVerification
                },
                {
                    key: 'birth',
                    label: i18n.t('person_page_text_birthday'),
                    disabledInput: editAccountMobx.disabled,
                    inputIsEdited: editAccountMobx.op.get('birth')?.now ? true : false,
                    comType: 'INPUT',
                    inputType: 'DATE',
                    handleChangePicker: (value) => {
                        const pickerValue = value ? moment(value).format(moment.HTML5_FMT.DATETIME_LOCAL_MS) : null;
                        const e = { target: { value: pickerValue ? pickerValue.toString() : null } };
                        editAccountMobx.handleChangeViewStaffBaseInfo(e, 'birth');
                    },
                    xs: 12,
                    md: 6,
                    isEmpty: editAccountMobx.allowNullVerification,
                    maxDate: new Date()
                },
            ]
        },
        {
            key: 'contact',
            title: i18n.t('restaurant_info_page_text_contact'),
            rowSpacing: 6,
            columnSpacing: { md: 4, xs: 4 },
            children: [
                {
                    key: 'phone_prefix',
                    label: i18n.t('general_text_country_code'),
                    disabledInput: editAccountMobx.disabled,
                    comType: 'INPUT',
                    inputType: 'COUNTRY_SELECT',
                    handleChangeCountry: (value) => {
                        const e = { target: { value } }
                        editAccountMobx.handleChangeViewStaffBaseInfo(e, 'phone_prefix');
                    },
                    xs: 12,
                    md: 3,
                },
                {
                    key: 'phone',
                    label: i18n.t('general_text_phone'),
                    required: true,
                    regularType: 'phone',
                    disabledInput: editAccountMobx.disabled,
                    comType: 'INPUT',
                    inputType: 'INPUT',
                    inputIsEdited: editAccountMobx.op.get('phone') !== undefined ? true : false,
                    onChange: (e) => {
                        editAccountMobx.handleChangeViewStaffBaseInfo(e, 'phone');
                    },
                    xs: 12,
                    md: 9,
                    isEmpty: editAccountMobx.allowNullVerification
                },
                {
                    key: 'email',
                    label: i18n.t('general_text_email'),
                    regularType: 'email',
                    disabledInput: editAccountMobx.disabled,
                    comType: 'INPUT',
                    inputType: 'INPUT',
                    inputIsEdited: editAccountMobx.op.get('email') !== undefined ? true : false,
                    onChange: (e) => {
                        editAccountMobx.handleChangeViewStaffBaseInfo(e, 'email');
                    },
                    xs: 12,
                    md: 12,
                    isEmpty: editAccountMobx.allowNullVerification
                },
                {
                    key: 'password',
                    subTitle: i18n.t('login_page_text_password'),
                    label: i18n.t('login_page_text_password'),
                    // 编辑员工信息，不校验必填；
                    required: belonged_restaurant === undefined,
                    disabledInput: editAccountMobx.disabled,
                    regularType: 'password',
                    comType: 'INPUT',
                    inputType: 'INPUT',
                    inputIsEdited: editAccountMobx.op.get('password') !== undefined ? true : false,
                    onChange: (e) => {
                        editAccountMobx.handleChangeViewStaffBaseInfo(e, 'password');
                    },
                    xs: 12,
                    isEmpty: editAccountMobx.allowNullVerification,
                    additionDescription: () => editing === null ? <></>
                        : <Box marginLeft={2} sx={{ fontSize: 12, flexDirection: editing?.is_edit_pass ? 'row-reverse' : undefined, justifyContent: 'space-between', alignItems: 'center', display: 'flex', }}>
                            {
                                editing?.is_edit_pass ?
                                    null
                                    :
                                    <Box display={'flex'} alignItems={'center'}>
                                        <ErrorOutlineIcon fontSize='small' />
                                        <span>{i18n.t('edit_account_user_had_not_change_paswword')}</span>
                                    </Box>
                            }
                            {/* 初始化密码按钮 */}
                            <Box>
                                <ButtonComponent
                                    titleText={i18n.t('ground_staff_component_text_initialize_password')}
                                    variant='outlined'
                                    space={false}
                                    children={<LockResetIcon />}
                                    handleClick={async () => {
                                        await editAccountMobx.initializePassword();
                                    }}
                                    disabled={editAccountMobx.disabled}
                                />
                            </Box>
                        </Box>
                },
            ]
        },
        {
            key: 'bind_restaurant',
            title: i18n.t('ground_staff_component_text_bound_restaurant'),
            rowSpacing: 6,
            hidden: belonged_restaurant === undefined ? true : false,
            xs: 12,
            md: 12,
            actionRender: (
                editAccountMobx.disabled ? <></> :
                    <ButtonComponent
                        variant='contained'
                        size='small'
                        handleClick={() => {
                            editAccountMobx.openCanCombindRestaurant();
                        }}
                        action={'ADD'}
                        titleText={i18n.t('dish_identify_page_text_new')}
                        buttonStyle={{ marginRight: 10 }}
                    />
            ),
            children: [
                {
                    key: 'belonged_restaurant',
                    comType: 'TABLE',
                    xs: 12,
                    md: 12,
                    tableConfig: {
                        headCellList: tableHead,
                        showChecked: 0,
                        list: JSON.stringify(editAccountMobx.viewStaffBaseInfo?.belonged_restaurant?.[0]) !== '{}' ? editAccountMobx.viewStaffBaseInfo?.belonged_restaurant || [] : [],
                    }
                }
            ]
        },
        {
            key: 'au_setting',
            title: i18n.t('edit_account_auth_setting'),
            rowSpacing: 4,
            xs: 12,
            md: 12,
            children: [
                {
                    key: 'au_group',
                    comType: 'CUSTOMCHILDREN',
                    xs: 12,
                    customSubChildren: (
                        <Box sx={{ width: '100%' }}>
                            {
                                <AuthGroup enterCompType={editing === null ? 'ADD' : 'EDIT'} accountInfo={editAccountMobx.viewStaffBaseInfo || {}} />
                            }
                        </Box>
                    )
                },
            ]
        }
    ];

    function renderFeatures(row: any) {
        const belonged_restaurants = editAccountMobx.viewStaffBaseInfo?.belonged_restaurant ?? [];
        const isCombined = belonged_restaurants.find(e => e._id === row._id) ? true : false;
        return (
            <>
                <ButtonComponent
                    // titleText=''
                    // variant='text'
                    // disabled={editAccountMobx.disabled}
                    variant='text'
                    sx={(theme) => { return { color: isCombined ? theme.palette.primary.main : theme.palette.secondary.main } }}
                    handleClick={async () => {
                        await editAccountMobx.combineOrNotRestaurant(row, isCombined);
                    }}
                // loadingStyle={{ width: '50%', height: '50%' }}
                >
                    <LinkIcon />
                </ButtonComponent>
            </>
        )
    }

    return (
        <div className='edit-account-container'>
            <DialogComponent className={'dialog-content'}
                {...{
                    defaultHeaderProps: {
                        title: editing === null ? i18n.t('ground_staff_component_text_new_create_employee') : i18n.t('ground_staff_component_text_edit_staff_account'),
                        onClose: () => {
                            if (editAccountMobx.close()) {
                                onClose();
                                editAccountMobx.reset();
                                authGroupData.reset();
                            }
                        },
                        rightNode: (
                            editAccountMobx.disabled ? <></>
                                :
                                <ButtonComponent
                                    async
                                    variant='outlined'
                                    handleClick={async () => {
                                        const suc = await editAccountMobx.save(accountInfoCardConfig);
                                        if (suc) {
                                            onClose();
                                            groupUnitData.getStaffsData();
                                            editAccountMobx.reset();
                                            authGroupData.reset();
                                        }
                                    }}
                                    titleText={i18n.t('dish_identify_page_text_save')}
                                >
                                    <Save className='iconColor' />
                                </ButtonComponent>
                        )
                    },
                    heightSize: 'large',
                    fullWidth: true,
                    maxWidth: 'xl',
                    open,
                    transitionDuration: {
                        appear: 450,
                        enter: 400,
                        exit: 300
                    },
                    footer: <></>
                }}
            >
                {
                    skeleton ? <SkeletonViewComp /> :
                        <CardFrom
                            config={accountInfoCardConfig}
                            data={editAccountMobx.viewStaffBaseInfo as {} || {}}
                        />
                }
                <DialogComponent
                    open={editAccountMobx.canCombindRestaurantData.open}
                    maxWidth={'md'}
                    heightSize='large'
                    defaultHeaderProps={{
                        title: i18n.t('ground_staff_component_text_associated_restaurant'),
                        // onClose: () => { editAccountMobx.setDiglog({ open: false }); },
                    }}
                    onClose={() => { editAccountMobx.closeCanCombindRestaurantDialog(); }}
                >
                    <Box className={'search-tool'} flexDirection='row'>
                        {/* 集团切换下拉框 */}
                        <Box className={'select-input'}>
                            <CommonInput
                                inputType={'SELECT'}
                                select={true}
                                items={groupModeOptions}
                                size={'small'}
                                fullWidth
                                value={editAccountMobx.canCombindRestaurantData.groupSelectVal || ''}
                                onChange={(e) => {
                                    const selectVal = e.target.value;
                                    editAccountMobx.updateGroupSelectValue(selectVal);
                                    editAccountMobx.searchCanCombineRestaurant(editAccountMobx.canCombindRestaurantData.currentSearchValue);
                                }}
                            />
                        </Box>
                        {/* 下拉框 */}
                        <Box className={'select-input'}>
                            <CommonInput
                                inputType={'SELECT'}
                                select={true}
                                items={filterList ?? []}
                                size={'small'}
                                fullWidth
                                value={editAccountMobx.canCombindRestaurantData.selectValue ?? ''}
                                onChange={(e) => {
                                    const selectVal = e.target.value;
                                    editAccountMobx.updateSearchSelectValue(selectVal);
                                    // editAccountMobx.searchCanCombineRestaurant(editAccountMobx.canCombindRestaurantData.currentSearchValue);
                                }}
                            />
                        </Box>
                        {/* 搜索框 */}
                        <SearchComponent
                            {...{
                                allowClear: true,
                                onSearch: (value) => {
                                    editAccountMobx.searchCanCombineRestaurant(value);
                                },
                                onChange: (value) => {
                                    editAccountMobx.updateCurrentSearchString(value);
                                }
                            }}
                        />
                    </Box>
                    <TableComponent
                        showChecked={0}
                        list={editAccountMobx.canCombindRestaurantData.list.map(item => ({
                            ...item,
                        })) ?? []}
                        headCellList={editAccountTableHead}
                        isTableLoading={editAccountMobx.canCombindRestaurantData.isLoading}
                        isPagination={true}
                        allCount={editAccountMobx.canCombindRestaurantData.totalCount}
                    />
                </DialogComponent>
                <DialogComponent
                    open={editAccountMobx.dialog.open}
                    maxWidth={'xs'}
                    defaultHeaderProps={{
                        title: editAccountMobx.dialog.title,
                        onClose: () => { editAccountMobx.setDiglog({ open: false }); },
                    }}
                    footer={
                        <>
                            {editAccountMobx.dialog.option && editAccountMobx.dialog.option.map((e: any, i: number) => {
                                return (
                                    <Button
                                        variant={i === 0 ? 'contained' : 'outlined'}
                                        key={e[0]} onClick={() => e[1]({ onClose })}>
                                        {e[0]}
                                    </Button>
                                )
                            })}
                        </>
                    }
                >
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        {
                            editAccountMobx.dialog.message && editAccountMobx.dialog.message.map(
                                (e: string, i) => (
                                    <Typography key={`${i}`} sx={{ marginBottom: 2 }}>
                                        {e}
                                    </Typography>
                                )
                            )
                        }
                    </div>
                </DialogComponent>
            </DialogComponent>
        </div >
    )
});

function SkeletonViewComp(): JSX.Element {
    return (
        <div className='skeleton'>
            <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                    <CardView
                        style={{ height: '100%' }}
                        contentRender={(
                            <Grid container rowSpacing={4}>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' width={90} height={25} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' width={140} height={140} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={80} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                            </Grid>
                        )}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <CardView
                        style={{ height: '100%' }}
                        contentRender={(
                            <Grid container rowSpacing={4}>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' width={90} height={25} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                            </Grid>
                        )}
                    />
                </Grid>
                <Grid item xs={12}>
                    <CardView
                        style={{ height: '100%' }}
                        contentRender={(
                            <Grid container rowSpacing={4}>
                                {/* <Grid item xs={12} sx={{ direction: 'rtl' }}>
                                                <Skeleton variant='rounded' width={30} height={30} animation='wave' />
                                            </Grid> */}
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' width={90} height={25} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={150} animation='wave' />
                                </Grid>
                            </Grid>
                        )}
                    />
                </Grid>
                <Grid item xs={12}>
                    <CardView
                        style={{ height: '100%' }}
                        contentRender={(
                            <Grid container rowSpacing={4} columnSpacing={{ xs: 2, sm: 2, md: 2 }}>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' width={90} height={25} animation='wave' />
                                </Grid>
                                <Grid item xs={12} md={1.5}>
                                    <Skeleton variant='rounded' height={100} animation='wave' />
                                </Grid>
                                <Grid item xs={12} md={10.5}>
                                    <Skeleton variant='rounded' sx={{ marginBottom: 2 }} height={45} animation='wave' />
                                    <Skeleton variant='rounded' height={45} animation='wave' />
                                </Grid>
                            </Grid>
                        )}
                    />
                </Grid>
            </Grid>
        </div>
    )
}
